export enum FeedbackInfoColorToken {
  feedbackColorInfoPure = '#317AEC',
  feedbackColorInfoLight = '#E4F3FF',
  feedbackColorInfoMedium = '#1F6EEA',
  feedbackColorInfoDark = '#1460D7',
}

export default FeedbackInfoColorToken

export type TInfo =
  | 'feedbackColorInfoPure'
  | 'feedbackColorInfoLight'
  | 'feedbackColorInfoMedium'
  | 'feedbackColorInfoDark'
